import settings from '@config/settings'
import { Link } from '@integrations/routing'
import { paths } from 'mmfintech-backend-api'
import BrandLogoImage from '../BrandLogoImage'

interface Props {
  isLoggedIn: boolean
}

function BrandLogo({ isLoggedIn }: Props) {
  return (
    <div>
      {isLoggedIn ? (
        <Link to={paths.dashboard()}>
          <BrandLogoImage />
        </Link>
      ) : (
        <a href={settings.landingPageUrl}>
          <BrandLogoImage />
        </a>
      )}
    </div>
  )
}

export default BrandLogo
